import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BookingFinalConfirmationTemplateWithDetail } from '../booking-final-confirmation-template-with-detail';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-booking-final-confirmation-template-edit',
  templateUrl: './booking-final-confirmation-template-edit.component.html',
  styleUrls: ['./booking-final-confirmation-template-edit.component.css']
})
export class BookingFinalConfirmationTemplateEditComponent implements OnInit {

  selectedTemplate!: BookingFinalConfirmationTemplateWithDetail;
  templateForm!: FormGroup;
  @ViewChild("textArea") textArea!: ElementRef;

  constructor(
    public pdfDocumentService: PdfDocumentTemplateService,
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    let templateId = this.pdfDocumentService.selectedFinalConfirmationTemplate.id;
    this.httpService.getBookingFinalConfirmationTemplateById(templateId).subscribe(res => {
      this.selectedTemplate = res;
      this.templateForm = this.builder.group({
        body: this.selectedTemplate.body,
        name: this.selectedTemplate.name
      });
    });
  }

  backtoTheList() {
    this.pdfDocumentService.activeItemId = PdfTemplateViewOption.FINAL_CONFIRMATIONS;
  }

  updateTemplate() {
    this.selectedTemplate.body = this.templateForm.value.body;
    this.httpService.updateBookingFinalConfirmationTemplate(new BookingFinalConfirmationTemplateWithDetail(
      this.selectedTemplate.id,
      this.templateForm.value.name,
      this.templateForm.value.body
    )).subscribe(() => {
      this.toastService.addSuccess("Success", "Template updated");
    }, error => {
      this.toastService.addError("Error", error.error.message);
    });
  }

  insertStrToTextArea(str: string) {
    if (this.textArea.nativeElement.selectionStart || this.textArea.nativeElement.selectionStaart == '0') {
      let startPos = this.textArea.nativeElement.selectionStart;
      let endPos = this.textArea.nativeElement.selectionEnd;
      this.textArea.nativeElement.value = this.textArea.nativeElement.value.substring(0, startPos) +
        str + this.textArea.nativeElement.value.substring(endPos, this.textArea.nativeElement.value.length);
    } else {
      this.textArea.nativeElement.value += str;
    }
  }

}
